import { PopOverItem } from 'components/PopOver/types'
import { ViewType } from 'types/global'
import { FilterKeys } from './types'

export enum FilterViewType {
  All = 'ALL',
  Open = 'OPEN',
  Converted = 'CONVERTED',
  Invalid = 'INVALID',
  Lost = 'LOST',
  Deleted = 'DELETED',
}

const FILTERS_CONFIG: { [key in FilterKeys]: PopOverItem<string> } = Object.freeze({
  additionalOwners: { label: 'collaborators_lbl', value: 'additionalOwners' },
  closedDate: { label: 'closed_date_lbl', value: 'closedDate' },
  closedReason: { label: 'closed_reason_lbl', value: 'closedReason' },
  closedBy: { label: 'closed_by_lbl', value: 'closedBy' },
  convertedBy: { label: 'converted_by_lbl', value: 'convertedBy' },
  convertedDate: { label: 'converted_date_lbl', value: 'convertedDate' },
  industries: { label: 'industry_lbl', value: 'industries' },
  leadCampaigns: { label: 'campaigns_lbl', value: 'campaigns' },
  leadInDate: { label: 'lead_in_date_lbl', value: 'leadInDate' },
  leadOwners: { label: 'lead_owner_lbl', value: 'leadOwners' },
  leadSources: { label: 'sources_lbl', value: 'sources' },
  leadSourceTypes: { label: 'source_type_lbl', value: 'leadSourceTypes' },
  leadStatuses: { label: 'status_lbl', value: 'leadStatuses' },
  leadTypes: { label: 'type_lbl', value: 'leadTypes' },
  priorities: { label: 'priority_lbl', value: 'priorities' },
  recycledStatus: { label: 'recycled_status_lbl', value: 'recycledStatus' },
  lastRecycledDate: { label: 'last_recycled_date_lbl', value: 'lastRecycledDate' },
  views: { label: 'views_lbl', value: 'views' },
  lastActivityOutcome: { label: 'last_activity_outcome', value: 'lastActivityOutcome' },
  nextActivityDate: { label: 'next_activity_date_lbl', value: 'nextActivityDate' },
  nextActivityStatus: { label: 'next_activity_status_lbl', value: 'nextActivityStatus' },
  leadMarketPotential: { label: 'market_potential_title_lbl', value: 'leadMarketPotential' },
  deletedBy: { label: 'deleted_by_lbl', value: 'deletedBy' },
  deletedDate: { label: 'deleted_date_lbl', value: 'deletedDate' },
  totalCalls: { label: 'total_calls_lbl', value: 'totalCalls' },
})

const DELETED_FILTERS: PopOverItem<string>[] = [
  { ...FILTERS_CONFIG.leadTypes, isDisabled: true },
  { ...FILTERS_CONFIG.leadOwners, isDisabled: true },
  { ...FILTERS_CONFIG.leadStatuses, isDisabled: true },
  { ...FILTERS_CONFIG.deletedBy, isDisabled: true },
  { ...FILTERS_CONFIG.deletedDate, isDisabled: true },
  FILTERS_CONFIG.closedDate,
  FILTERS_CONFIG.closedBy,
  FILTERS_CONFIG.convertedDate,
  FILTERS_CONFIG.convertedBy,
  FILTERS_CONFIG.leadMarketPotential,
  FILTERS_CONFIG.leadInDate,
  FILTERS_CONFIG.leadCampaigns,
  FILTERS_CONFIG.leadSources,
  FILTERS_CONFIG.leadSourceTypes,
  FILTERS_CONFIG.additionalOwners,
  FILTERS_CONFIG.industries,
  FILTERS_CONFIG.lastActivityOutcome,
  FILTERS_CONFIG.nextActivityStatus,
  FILTERS_CONFIG.nextActivityDate,
  FILTERS_CONFIG.totalCalls,
]

const LOST_INVALID_FILTERS: PopOverItem<string>[] = [
  { ...FILTERS_CONFIG.leadTypes, isDisabled: true },
  { ...FILTERS_CONFIG.leadOwners, isDisabled: true },
  { ...FILTERS_CONFIG.closedDate, isDisabled: true },
  { ...FILTERS_CONFIG.closedReason, isDisabled: true },
  { ...FILTERS_CONFIG.leadInDate, isDisabled: true },
  FILTERS_CONFIG.leadMarketPotential,
  FILTERS_CONFIG.leadCampaigns,
  FILTERS_CONFIG.leadSources,
  FILTERS_CONFIG.leadSourceTypes,
  FILTERS_CONFIG.additionalOwners,
  FILTERS_CONFIG.industries,
  FILTERS_CONFIG.nextActivityStatus,
  FILTERS_CONFIG.nextActivityDate,
  FILTERS_CONFIG.totalCalls,
]
export const FILTERS: { [key in keyof typeof FilterViewType]: PopOverItem<string>[] } = {
  Converted: [
    { ...FILTERS_CONFIG.leadTypes, isDisabled: true },
    { ...FILTERS_CONFIG.leadOwners, isDisabled: true },
    { ...FILTERS_CONFIG.convertedDate, isDisabled: true },
    FILTERS_CONFIG.leadMarketPotential,
    FILTERS_CONFIG.leadInDate,
    FILTERS_CONFIG.convertedBy,
    FILTERS_CONFIG.leadCampaigns,
    FILTERS_CONFIG.leadSources,
    FILTERS_CONFIG.leadSourceTypes,
    FILTERS_CONFIG.additionalOwners,
    FILTERS_CONFIG.industries,
    FILTERS_CONFIG.lastActivityOutcome,
    FILTERS_CONFIG.nextActivityStatus,
    FILTERS_CONFIG.nextActivityDate,
    FILTERS_CONFIG.totalCalls,
  ],
  Deleted: DELETED_FILTERS,
  Invalid: LOST_INVALID_FILTERS,
  Lost: LOST_INVALID_FILTERS,
  Open: [
    { ...FILTERS_CONFIG.leadTypes, isDisabled: true },
    { ...FILTERS_CONFIG.priorities, isDisabled: true },
    { ...FILTERS_CONFIG.leadStatuses, isDisabled: true },
    { ...FILTERS_CONFIG.leadOwners, isDisabled: true },
    FILTERS_CONFIG.leadMarketPotential,
    FILTERS_CONFIG.leadCampaigns,
    FILTERS_CONFIG.leadSources,
    FILTERS_CONFIG.leadSourceTypes,
    FILTERS_CONFIG.additionalOwners,
    FILTERS_CONFIG.leadInDate,
    FILTERS_CONFIG.industries,
    FILTERS_CONFIG.recycledStatus,
    FILTERS_CONFIG.lastRecycledDate,
    FILTERS_CONFIG.lastActivityOutcome,
    FILTERS_CONFIG.nextActivityStatus,
    FILTERS_CONFIG.nextActivityDate,
    FILTERS_CONFIG.totalCalls,
  ],
  All: [
    { ...FILTERS_CONFIG.leadTypes, isDisabled: true },
    { ...FILTERS_CONFIG.priorities, isDisabled: true },
    { ...FILTERS_CONFIG.leadStatuses, isDisabled: true },
    { ...FILTERS_CONFIG.leadOwners, isDisabled: true },
    FILTERS_CONFIG.leadMarketPotential,
    FILTERS_CONFIG.leadCampaigns,
    FILTERS_CONFIG.leadSources,
    FILTERS_CONFIG.leadSourceTypes,
    FILTERS_CONFIG.additionalOwners,
    FILTERS_CONFIG.leadInDate,
    FILTERS_CONFIG.industries,
    FILTERS_CONFIG.recycledStatus,
    FILTERS_CONFIG.lastRecycledDate,
    FILTERS_CONFIG.lastActivityOutcome,
    FILTERS_CONFIG.nextActivityStatus,
    FILTERS_CONFIG.nextActivityDate,
    FILTERS_CONFIG.closedReason,
    FILTERS_CONFIG.totalCalls,
  ],
}

export const DEFAULT_SELECTED_FILTER_KEYS: { [key in ViewType]: string[] } = {
  CONVERTED: [FILTERS_CONFIG.leadTypes.value, FILTERS_CONFIG.leadOwners.value, FILTERS_CONFIG.convertedDate.value],
  DELETED: [
    FILTERS_CONFIG.leadTypes.value,
    FILTERS_CONFIG.leadStatuses.value,
    FILTERS_CONFIG.deletedBy.value,
    FILTERS_CONFIG.deletedDate.value,
  ],
  INVALID: [
    FILTERS_CONFIG.leadTypes.value,
    FILTERS_CONFIG.leadOwners.value,
    FILTERS_CONFIG.closedDate.value,
    FILTERS_CONFIG.closedReason.value,
    FILTERS_CONFIG.closedBy.value,
    FILTERS_CONFIG.leadInDate.value,
    FILTERS_CONFIG.nextActivityDate.value,
  ],
  LOST: [
    FILTERS_CONFIG.leadTypes.value,
    FILTERS_CONFIG.leadOwners.value,
    FILTERS_CONFIG.closedDate.value,
    FILTERS_CONFIG.closedReason.value,
    FILTERS_CONFIG.closedBy.value,
    FILTERS_CONFIG.leadInDate.value,
    FILTERS_CONFIG.nextActivityDate.value,
  ],
  OPEN: [
    FILTERS_CONFIG.leadTypes.value,
    FILTERS_CONFIG.priorities.value,
    FILTERS_CONFIG.leadStatuses.value,
    FILTERS_CONFIG.leadOwners.value,
    FILTERS_CONFIG.nextActivityDate.value,
  ],
  ALL: [
    FILTERS_CONFIG.leadTypes.value,
    FILTERS_CONFIG.priorities.value,
    FILTERS_CONFIG.leadStatuses.value,
    FILTERS_CONFIG.leadOwners.value,
    FILTERS_CONFIG.nextActivityDate.value,
  ],
}

export const FILTER_KEYS = {
  [FilterViewType.All]: FILTERS.All,
  [FilterViewType.Open]: FILTERS.Open,
  [FilterViewType.Converted]: FILTERS.Converted,
  [FilterViewType.Invalid]: FILTERS.Invalid,
  [FilterViewType.Lost]: FILTERS.Lost,
  [FilterViewType.Deleted]: FILTERS.Deleted,
}

export const MARKET_POTENTIAL_ALL = 'all'
export const MARKET_POTENTIAL_EMPTY = 'empty'
export const MARKET_POTENTIAL_NOT_EMPTY = 'notEmpty'

export const MARKET_POTENTIAL_OPERATORS = {
  betweenAnd: 'OPERAND_BETWEEN_AND' as const,
  notBetweenAnd: 'OPERAND_NOT_BETWEEN_AND' as const,
  equal: 'OPERAND_EQUAL' as const,
  notEqual: 'OPERAND_NOT_EQUAL' as const,
  lessThan: 'OPERAND_LESS_THAN' as const,
  greaterThan: 'OPERAND_GREATER_THAN' as const,
  lessOrEqual: 'OPERAND_LESS_OR_EQUAL' as const,
  greaterOrEqual: 'OPERAND_GREATER_OR_EQUAL' as const,
  notNull: 'OPERAND_IS_NOT_NULL' as const,
  null: 'OPERAND_IS_NULL' as const,
}

export const MARKET_POTENTIAL_RANGE_KEYS = {
  min: 'min',
  max: 'max',
}

export const TEAM_TYPE = 'team'
export const USER_TYPE = 'user'
